import { useEffect, useSyncExternalStore } from 'react';
import {
  DEFAULT_PRODUCT_TILE_FEATURES,
  getProductTileFeatures,
  loadProductConfig,
  loadProductTileFeaturesFromStorage,
  subscribeToProductTileFeatures,
} from '@loomstateorg/shared-frontend';
import type { ProductTileFeatures } from '@loomstateorg/shared-frontend';

const getServerSnapshot = () => DEFAULT_PRODUCT_TILE_FEATURES;

/**
 * Per-site toggles for the optional product card features, read from the
 * `productsConfig` custom object. The values are cached, so cards usually render
 * with the resolved configuration on their first paint.
 *
 * The hook lives in the app rather than in the shared package because hooks have
 * to run against the application's React instance.
 */
const useProductTileFeatures = (): ProductTileFeatures => {
  const features = useSyncExternalStore(subscribeToProductTileFeatures, getProductTileFeatures, getServerSnapshot);

  useEffect(() => {
    loadProductTileFeaturesFromStorage();
    loadProductConfig();
  }, []);

  return features;
};

export default useProductTileFeatures;
